import React from 'react';
import { Modal, Upload, Button } from 'antd';

interface ImageUploadModalProps {
    visible: boolean;
    onUpload: (file: File) => void;
    onCancel: () => void;
}

export const ImageUploadModal: React.FC<ImageUploadModalProps> = ({
    visible,
    onUpload,
    onCancel
}) => {
    return (
        <Modal
            title="Upload Image"
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={400}
        >
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <Upload.Dragger
                    accept="image/*"
                    showUploadList={false}
                    beforeUpload={(file) => {
                        onUpload(file);
                        return false;
                    }}
                    style={{ marginBottom: 16 }}
                >
                    <div style={{ padding: 20 }}>
                        <div style={{ fontSize: 48, marginBottom: 16 }}>🖼️</div>
                        <p style={{ fontSize: 16, marginBottom: 8 }}>Click or drag image to upload</p>
                        <p style={{ color: '#999', fontSize: 14 }}>Supports: JPG, PNG, GIF, WebP</p>
                    </div>
                </Upload.Dragger>
                <Button onClick={onCancel}>Cancel</Button>
            </div>
        </Modal>
    );
};